module.exports = __webpack_public_path__ + "img/empty.909ce196.png";